export default __webpack_public_path__ + "static/media/Certilytics-Logo-Icons-9.346bc525.svg";